import { AxiosError } from "axios";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import DismissAction from "../components/common/dismiss_action";

function messageFromError(error: unknown): string | undefined {
  if (typeof error === "string") return error;
  const msg = (
    error as AxiosError<{
      message?: string | string[];
      success?: boolean;
    }>
  ).response?.data?.message;
  if (Array.isArray(msg)) return msg.join(", ");
  if (typeof msg === "string") return msg;
  return undefined;
}

export function useErrorSnackbar({
  isError,
  error,
}: {
  isError: boolean;
  error: any;
}) {
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if (isError) {
      enqueueSnackbar(messageFromError(error) ?? "Something went wrong", {
        variant: "error",
        action: DismissAction,
      });
    }
  }, [isError, error, enqueueSnackbar]);
}
